"use client";
import { Alert, type AlertProps, Typography, useTheme } from "@mui/material";
import { CircleAlertIcon, CircleCheckIcon, CircleXIcon } from "lucide-react";

interface ToastProps extends AlertProps {
	message?: string;
}

export function Toast({
	icon,
	sx,
	children,
	severity,
	message,
	...props
}: Readonly<ToastProps>) {
	const theme = useTheme();

	const icons = {
		info: <CircleAlertIcon />,
		warning: <CircleAlertIcon />,
		success: <CircleCheckIcon />,
		error: <CircleXIcon />,
	};

	return (
		<Alert
			ref={props.ref}
			icon={severity ? icons[severity] : <CircleAlertIcon />}
			sx={{
				backgroundColor: severity
					? theme.palette[severity].background
					: theme.palette.background.paper,
				borderColor: severity
					? theme.palette[severity].light
					: theme.palette.muted.dark,
				borderRadius: theme.spacing(1.5),
				boxShadow: "1px 3px 6px rgba(0, 0, 0, 0.1)",
				color: severity
					? theme.palette[severity].dark
					: theme.palette.text.primary,
				svg: {
					color: severity
						? theme.palette[severity].main
						: theme.palette.text.primary,
					height: theme.spacing(2.75),
					wigth: theme.spacing(2.75),
				},
				...sx,
			}}
			{...props}
		>
			{message && <Typography variant="body2">{message}</Typography>}
			{children}
		</Alert>
	);
}
